/**
 * Gigs API constants
 */

/**
 * Default number of gigs to load per page
 */
export const DEFAULT_PAGINATION_PAGE_SIZE = 21;

/**
 * Default number of invites to load
 */
export const DEFAULT_INVITES_LIMIT = 3;

/**
 * API filter parameters
 */
export const API_FILTERS = {
  /**
   * Filter to exclude invites from gigs listing
   */
  WITHOUT_INVITES: 'without_invites',

  /**
   * Filter to show only invited items
   */
  INVITED: 'invited',
};

/**
 * API include parameters for expanding related resources
 */
export const API_INCLUDES = {
  DELIVERABLES: 'deliverables',
  PREFERRED_CREATOR_PROFILE: 'preferred_creator_profile',
  CAMPAIGN_MERCHANT: 'campaign.merchant',
  SOCIAL_NETWORK: 'social_network',
  USER_CAMPAIGN_LIST_ITEM: 'user_campaign_list_item',
  USER_CAMPAIGN_LIST_ITEM_DELIVERABLES: 'user_campaign_list_item.deliverables',
  USER_CAMPAIGN_LIST_ITEM_PREFERRED_PROFILE:
    'user_campaign_list_item.preferred_creator_profile',
};

/**
 * Common API parameter combinations
 */
export const API_PARAM_SETS = {
  /**
   * Standard includes for gigs API
   */
  STANDARD_INCLUDES: [
    API_INCLUDES.DELIVERABLES,
    API_INCLUDES.PREFERRED_CREATOR_PROFILE,
  ],

  /**
   * Standard includes for invites API
   */
  INVITED_GIGS_INCLUDES: [
    API_INCLUDES.USER_CAMPAIGN_LIST_ITEM,
    API_INCLUDES.USER_CAMPAIGN_LIST_ITEM_DELIVERABLES,
    API_INCLUDES.USER_CAMPAIGN_LIST_ITEM_PREFERRED_PROFILE,
  ],

  /**
   * Standard includes for paid gigs API
   */
  PAID_GIGS_INCLUDES: [
    API_INCLUDES.CAMPAIGN_MERCHANT,
    API_INCLUDES.DELIVERABLES,
    API_INCLUDES.SOCIAL_NETWORK,
  ],
};
